import React from 'react';
import { Box, Typography } from '@mui/material';
import { AGUARDANDO_DIGITACAO, EM_DIGITACAO } from '../../../../constants/status';
import { renderStatus } from '../../../../components/v2/cell-renderers/status';
import { statusToChip } from '../../RelatorioDigitacao/constants';
import {
  cellContentSx,
  LabeledLine,
  renderTipoServicoSubtipo,
} from '../../RelatorioDigitacao/tableCells';
import { formatDigitadoEm } from '../../Nsir/mtbt/utils/integracaoStatus';

export { renderTipoServicoSubtipo };

const nsirLinkSx = {
  color: 'info.main',
  fontWeight: 600,
  textDecoration: 'underline',
  verticalAlign: 'baseline',
  '&:hover': {
    color: 'info.dark',
    textDecoration: 'underline',
  },
};

const renderNsirLink = (row) => {
  const { nsirId, nsirCodigo } = row;
  if (!nsirCodigo) return '—';
  if (!nsirId) return nsirCodigo;
  const href = `${window.location.origin}/v2/nsir/${nsirId}`;
  return (
    <Box
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      sx={{ ...nsirLinkSx, display: 'inline' }}
    >
      {nsirCodigo}
    </Box>
  );
};

export const renderNsirCodigoEquipamento = (row) => (
  <Box sx={cellContentSx}>
    <Typography variant="body2" noWrap title={row.nsirCodigo ? String(row.nsirCodigo) : undefined}>
      {renderNsirLink(row)}
    </Typography>
    <LabeledLine
      label="Equipamento: "
      value={row.equipamentoNome ?? row.equipamento}
    />
  </Box>
);

export const renderMalhaPoloAlimentador = (row) => (
  <Box sx={cellContentSx}>
    <LabeledLine label="Malha: " value={row.malhaNome} />
    <LabeledLine label="Polo: " value={row.poloNome} />
    <LabeledLine label="Alimentador: " value={row.alimentadorNome} />
  </Box>
);

export const renderStatusComDataDigitacao = (row) => {
  const showDate = row.status
    && row.status !== AGUARDANDO_DIGITACAO
    && row.status !== EM_DIGITACAO;
  const dateLabel = showDate ? (formatDigitadoEm(row.dataDigitacao) ?? '—') : null;

  return (
    <Box sx={cellContentSx}>
      <Box sx={{ display: 'inline-flex' }}>
        {row.status ? renderStatus(statusToChip(row.status)) : '—'}
      </Box>
      {dateLabel && (
        <Typography variant="caption" color="text.secondary" noWrap>
          {dateLabel}
        </Typography>
      )}
    </Box>
  );
};
